import LegalLayout, { Section } from "@/pages/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service">
      <p>
        Welcome to Gens Realty. By accessing our website, calling our AI receptionist
        (&quot;Gentry&quot;), submitting information through our chat, or using any of our
        services, you agree to these Terms of Service. Please read them carefully.
      </p>

      <Section heading="1. Real Estate Services">
        <p>
          Gens Realty is a licensed real estate brokerage in the State of Texas providing
          home sales, residential rentals, and (coming soon) property management.
          Information provided through Gentry (chat, phone, or forms) is used solely to
          respond to your inquiry and, when applicable, to connect you with a licensed
          agent.
        </p>
      </Section>

      <Section heading="2. SMS Program Terms">
        <p>
          When you opt in by checking the SMS consent box on any Gens Realty form, you
          agree to receive text (SMS) messages from Gens Realty at the phone number you
          provide. Program details:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Program name: Gens Realty Customer Notifications</li>
          <li>Message purpose: appointment confirmations, follow-ups on your request, and occasional listing updates you asked about</li>
          <li>Message frequency varies</li>
          <li>Message and data rates may apply. Consult your mobile carrier.</li>
          <li>Reply <strong>STOP</strong> at any time to unsubscribe. Reply <strong>HELP</strong> for assistance.</li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
          <li>Consent is not a condition of purchase or of receiving any real estate service.</li>
        </ul>
        <p>
          To unsubscribe, reply STOP to any message we send. For help, reply HELP or
          contact us at{" "}
          <a className="underline" href="tel:+13466992755">(346) 699-2755</a> or{" "}
          <a className="underline" href="mailto:hello@gensrealty.com">
            hello@gensrealty.com
          </a>
          .
        </p>
      </Section>

      <Section heading="3. Chat &amp; Voice Recordings">
        <p>
          Conversations with Gentry (web chat and phone) may be transcribed and stored
          so our staff can follow up and improve service. By using Gentry you consent
          to this recording and storage.
        </p>
      </Section>

      <Section heading="4. No Guarantee of Availability">
        <p>
          Property availability, pricing, and appointment times are subject to change and
          are not guaranteed until confirmed by a licensed Gens Realty agent.
        </p>
      </Section>

      <Section heading="5. Governing Law">
        <p>
          These Terms are governed by the laws of the State of Texas without regard to
          conflict-of-law principles. Any dispute will be brought in a state or federal
          court located in Harris County, Texas.
        </p>
      </Section>

      <Section heading="6. Contact">
        <p>
          Gens Realty · Houston, TX
          <br />
          Phone: <a className="underline" href="tel:+13466992755">(346) 699-2755</a>
          <br />
          Email:{" "}
          <a className="underline" href="mailto:hello@gensrealty.com">
            hello@gensrealty.com
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
}
